import { css } from "@emotion/css";
import { DateSegment } from "react-aria-components";

import { _DateInput } from "../assets/_DateInput";
import { useDatePickerStyles } from "../utils";

interface DatePickerInputProps {
  slot?: string;
}

export function DatePickerInput({ slot }: DatePickerInputProps) {
  const styles = useDatePickerStyles();
  return (
    <_DateInput
      slot={slot}
      className={css({
        gap: "var(--space-05)",
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
      })}
    >
      {(segment) => {
        return (
          <DateSegment
            className={css(
              styles.dateSegment,
              segment?.isEditable && styles.input
            )}
            segment={segment}
          />
        );
      }}
    </_DateInput>
  );
}
